import { Trophy } from "lucide-react";
import { Card, CardHeader, CardContent } from "@/components/ui/card";
import { Typography } from "@/components/ui/typography";

const SwimmersDiaryStub = () => {
  return (
    <Card className="overflow-hidden border-b">
      <CardHeader className="w-[calc(100vw-1.5rem)] border-b bg-muted/50 px-0 pt-0 md:w-[calc(100vw-250px-1.5rem)] lg:w-[50.4rem]">
        <div className="flex flex-col">
          <div className="group mr-auto flex items-center gap-3 pl-6 pt-6">
            <div className="rounded-lg bg-primary/10 p-3 text-primary">
              <Trophy className="h-6 w-6" />
            </div>
            <Typography
              variant="h3"
              className="text-lg font-normal text-gray-800 transition-colors group-hover:text-primary"
            >
              Дневник Пловца
            </Typography>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4 px-0 pb-0">
        <div className="relative">
          {/* Фоновый градиент */}
          <div className="absolute -inset-1 rounded-xl opacity-20 blur-md" />

          {/* Контент */}
          <div className="relative mx-auto max-w-[1000px] rounded-xl p-6">
            <Typography variant="p" className="text-base leading-relaxed">
              Это ключевой элемент методики АкваСтар. После каждого занятия инструктор фиксирует
              достижения, чтобы вы могли видеть, как уверенно растут навыки вашего ребенка.
            </Typography>
            <Typography variant="muted" className="mt-4 block">
              Приобрести дневник можно у администратора. В этом разделе будут отображаться все
              освоенные умения.
            </Typography>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SwimmersDiaryStub;
